export default "__VITE_ASSET__CXNmz6dW__"